import MoreVertIcon from "@mui/icons-material/MoreVert";
import wallet from 'assets/images/wallet.svg';
import tick from 'assets/images/tick.svg';
import cross from 'assets/images/cross.svg';
import star from 'assets/images/Star.svg';
import clap from 'assets/images/clapping.svg';
import coin from 'assets/images/coin.svg';

export const driverTableData = {
  header: [
    {
      label: "ID",
      key: "id",
    },
    {
      label: "Vehicle Name",
      key: "vehicleName",
    },
    {
      label: "Type",
      key: "type",
    },
    {
        label: "Rc Owner",
        key: "rcOwner",
      },
    {
      label: "Ride",
      key: "ride",
    },
    {
      label: "Location",
      key: "location",
    },
    {
        label: "Rating",
        key: "rating",
      },
    {
      label: "",
      key: "icon",
    },
  ],
  body: [
    {
      id: "1",
      vehicleName: "Maruti 800",
      vehicleImage: "image",
      vehicleNumber: "KA 05 MB 0001",
      type: "Mini",
      rcOwner: "Gokul",
      ride: "200",
      location: "Bangalore",
      rating: "3",
      icon: <MoreVertIcon />,
    },
    {
        id: "1",
        vehicleName: "Maruti 800",
        vehicleImage: "image",
        vehicleNumber: "KA 05 MB 0001",
        type: "Mini",
        rcOwner: "Gokul",
        ride: "200",
        location: "Bangalore",
        rating: "3",
        icon: <MoreVertIcon />,
      },
      {
        id: "1",
        vehicleName: "Maruti 800",
        vehicleImage: "image",
        vehicleNumber: "KA 05 MB 0001",
        type: "Mini",
        rcOwner: "Gokul",
        ride: "200",
        location: "Bangalore",
        rating: "3",
        icon: <MoreVertIcon />,
      },
      {
        id: "1",
        vehicleName: "Maruti 800",
        vehicleImage: "image",
        vehicleNumber: "KA 05 MB 0001",
        type: "Mini",
        rcOwner: "Gokul",
        ride: "200",
        location: "Bangalore",
        rating: "3",
        icon: <MoreVertIcon />,
      },
      {
        id: "1",
        vehicleName: "Maruti 800",
        vehicleImage: "image",
        vehicleNumber: "KA 05 MB 0001",
        type: "Mini",
        rcOwner: "Gokul",
        ride: "200",
        location: "Bangalore",
        rating: "3",
        icon: <MoreVertIcon />,
      },
      {
        id: "1",
        vehicleName: "Maruti 800",
        vehicleImage: "image",
        vehicleNumber: "KA 05 MB 0001",
        type: "Mini",
        rcOwner: "Gokul",
        ride: "200",
        location: "Bangalore",
        rating: "3",
        icon: <MoreVertIcon />,
      },
  ],
};


export const matrixDriverData= (details, matrix) => [
  {
      id:1,
      icon:wallet,
      amt:matrix?.totalRide || '0',
      name:"Total Trip"
  },
  {
      id:2,
      icon:tick,
      amt:matrix?.completedRide || '0',
      name:"Completed Trip"
  },
  {
      id:3,
      icon:cross,
      amt:matrix?.cancelRide || '0',
      name:"Canceled Trip"
  },
  // {
  //     id:4,
  //     icon:star,
  //     amt:details?.rating || '',
  //     name:"Total Ratings"
  // },
  {
      id:5,
      icon:clap,
      amt:matrix?.claps || '0',
      name:"Total Claps"
  },
  {
      id:6,
      icon:coin,
      amt:matrix?.totalCreditPoints || '0',
      name:"Total Credit Points"
  }
]

export const DriverTicketData =
{
    header: [
        {
            label: 'Compliance ID',
            key: 'complainceId',
        },
        {
            label: 'Date',
            key: 'date',
        },
        {
            label: 'Location',
            key: 'location',
        },
        {
            label: 'Description',
            key: 'description',
        },
        {
            label: 'Status',
            key: 'status',
        },
        {
            label: '',
            key: 'icon',
        },
    ],
    body: [
        {
            complainceId: '1',
            date: '8989891213',
            location: 'Bangalore',
            description: 'Lorem ipsum dolor sit amet consectetur. At sollicitudin mauris dolor eget venenatis',
            status: 'Pending',
            icon: <MoreVertIcon />
        },
        {
            complainceId: '2',
            date: '8789891213',
            location: 'Bangalore',
            description: 'Lorem ipsum dolor sit amet consectetur. At sollicitudin mauris dolor eget venenatis',
            status: 'Resolved',
            icon: <MoreVertIcon />
        },
    ]
}

//Add Driver Dialog data
export const driverDialogData = [
  {
    placeholder: 'Name',
    required: true,
    type: 'text',
    name: 'driverName',
    label: 'Driver Name',
    star: '*',
    countrycode: false,
  },
  
  {
    placeholder: 'Mobile Number',
    required: true,
    type: 'number',
    name: 'number',
    label: 'Mobile Number',
    star: '*',
    countrycode: true,
  },
  {
    placeholder: 'Email',
    required: true,
    type: 'text',
    name: 'email',
    label: 'Email ID',
    star: '*',
    countrycode: false,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    star: '*',
    countrycode: false,
    disabled: true,
  },
];

//Edit Driver Dialog Data
export const editDriverDialogData = (details) =>[
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue:details?.mobile?.replaceAll("+91","") || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue:details?.email || '',
  },
  
];